export const data = [
    {
      no: 1,
      username: 'Beetlejuice',
      datetime: '1988',
      usermode: 'Thoughtful',
      detailsupdate: 'Order Related',
      categoryone: 'Everything Period',
      categorytwo: 'Everything Period',
      querydetails: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
      status: 'Pending',
      actiondetails: 'View | Action'
    },
    {
      no: 2,
      username: 'Beetlejuice',
      datetime: '12 Mar 2023 06:15 PM',
      usermode: 'Comforting',
      detailsupdate: 'Order Related',
      categoryone: 'Everything Period',
      categorytwo: 'Everything Period',
      querydetails: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
      status: 'Pending',
      actiondetails: 'View | Action'
    },
    {
      no: 3,

      username: 'Beetlejuice',
      datetime: '1988',
      usermode: 'Comforting',
      detailsupdate: 'Order Related',
      categoryone: 'Everything Period',
      categorytwo: 'Everything Period',
      querydetails: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
      status: 'Pending',
      actiondetails: 'View | Action'
    },
    {
      no: 4,

      username: 'Beetlejuice',
      datetime: '12 Mar 2023 06:15 PM',
      usermode: 'Comforting',
      detailsupdate: 'Order Related',
      categoryone: 'Everything Period',
      categorytwo: 'Everything Period',
      querydetails: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
      status: 'Pending',
      actiondetails: 'View | Action'
    },
    {
      no: 5,

      username: 'Beetlejuice',
      datetime: '12 Mar 2023 06:15 PM',
      usermode: 'Thoughtful',
      detailsupdate: 'Order Related',
      categoryone: 'Everything Period',
      categorytwo: 'Everything Period',
      querydetails: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
      status: 'Pending',
      actiondetails: 'View | Action'
    },
    {
      no: 1,
      username: 'Beetlejuice',
      datetime: '12 Mar 2023 06:15 PM',
      usermode: 'Comforting',
      detailsupdate: 'Order Related',
      categoryone: 'Everything Period',
      categorytwo: 'Everything Period',
      querydetails: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
      status: 'Pending',
      actiondetails: 'View | Action'
    },
    {
      no: 2,
      username: 'Beetlejuice',
      datetime: '1988',
      usermode: 'Thoughtful',
      detailsupdate: 'Order Related',
      categoryone: 'Everything Period',
      categorytwo: 'Everything Period',
      querydetails: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
      status: 'Pending',
      actiondetails: 'View | Action'
    },
    {
      no: 3,

      username: 'Beetlejuice',
      datetime: '1988',
      usermode: 'Comforting',
      detailsupdate: 'Order Related',
      categoryone: 'Everything Period',
      categorytwo: 'Everything Period',
      querydetails: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
      status: 'Pending',
      actiondetails: 'View | Action'
    },
    {
      no: 4,

      username: 'Beetlejuice',
      datetime: '12 Mar 2023 06:15 PM',
      usermode: 'Thoughtful',
      detailsupdate: 'Order Related',
      categoryone: 'Everything Period',
      categorytwo: 'Everything Period',
      querydetails: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
      status: 'Pending',
      actiondetails: 'View | Action'
    },
    {
      no: 5,

      username: 'Beetlejuice',
      datetime: '1988',
      usermode: 'Thoughtful',
      detailsupdate: 'Order Related',
      categoryone: 'Everything Period',
      categorytwo: 'Everything Period',
      querydetails: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
      status: 'Pending',
      actiondetails: 'View | Action'
    },{
      no: 1,
      username: 'Beetlejuice',
      datetime: '12 Mar 2023 06:15 PM',
      usermode: 'Comforting',
      detailsupdate: 'Order Related',
      categoryone: 'Everything Period',
      categorytwo: 'Everything Period',
      querydetails: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
      status: 'Pending',
      actiondetails: 'View | Action'
    },
    {
      no: 2,
      username: 'Beetlejuice',
      datetime: '12 Mar 2023 06:15 PM',
      usermode: 'Comforting',
      detailsupdate: 'Order Related',
      categoryone: 'Everything Period',
      categorytwo: 'Everything Period',
      querydetails: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
      status: 'Pending',
      actiondetails: 'View | Action'
    },
    {
      no: 3,

      username: 'Beetlejuice',
      datetime: '1988',
      usermode: 'Comforting',
      detailsupdate: 'Order Related',
      categoryone: 'Everything Period',
      categorytwo: 'Everything Period',
      querydetails: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
      status: 'Pending',
      actiondetails: 'View | Action'
    },
    {
      no: 4,

      username: 'Beetlejuice',
      datetime: '1988',
      usermode: 'Comforting',
      detailsupdate: 'Order Related',
      categoryone: 'Everything Period',
      categorytwo: 'Everything Period',
      querydetails: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
      status: 'Pending',
      actiondetails: 'View | Action'
    },
    {
      no: 5,

      username: 'Beetlejuice',
      datetime: '1988',
      usermode: 'Comforting',
      detailsupdate: 'Order Related',
      categoryone: 'Everything Period',
      categorytwo: 'Everything Period',
      querydetails: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
      status: 'Pending',
      actiondetails: 'View | Action'
    }
  ]


 